import React from 'react';
import SectionItem from './SectionItem';
import { getOrgAddInfoArray } from '../../common/objectToArray';

const SectionContent = ({
	body,
	parentId,
	params,
	orgConfig,
	setBody,
	showAddMore = true,
	type,
	errors,
	edit,
	leadId,
	selectedLender,
	setErrors,
	title
}) => {
	const addNewSection = e =>
		setBody(values => {
			let addObj = {};
			if (parentId === 'more_info') {
				addObj.COLLATERAL_ID = 'COLLID' + leadId + (new Date()).getTime();
			}
			return {
				...values,
				...body,
				[parentId]: [...body[parentId], addObj]
			};
		});

	const removeSection = index => {
		const changes = body[parentId].filter((section, idx) => idx !== index);
		setBody(values => {
			return { ...values, ...body, [parentId]: changes };
		});
	};
	if (type === 'multiple')
		return (
			<>
				{(body[parentId] || []).map(({ }, parentIndex) => (
					<>
						{parentIndex == 0 && (
							<>
								<p style={{ fontSize: '13px', color: '#ea652b', marginTop: '-8px' }}>{`${title?.split(' ')[0]} Info ${parentIndex + 1}`}</p>
							</>
						)}
						<div className='row mt-3'>
							{getOrgAddInfoArray(orgConfig[parentIndex] ?? params).map(({ label, value, id, rule, hint }, index) => (
								<SectionItem
									required={value}
									parentIndex={parentIndex}
									type={type}
									body={body}
									setBody={setBody}
									parentId={parentId}
									label={label}
									hint={hint}
									key={index}
									id={id}
									rule={rule}
									sectionIndex={index}
									params={getOrgAddInfoArray(orgConfig[parentIndex] ?? params)}
									errors={errors}
									edit={edit}
									leadId={leadId}
									selectedLender={selectedLender}
									setErrors={setErrors}
								/>
							))}
							{!(showAddMore && parentIndex >= 1) && (
								<div className='col-md-44' style={{ 'width': '87%', 'height': '18px' }}>
								</div>
							)}

							{showAddMore && parentIndex >= 1 && (
								<div className='col-md-44' style={{ 'width': 'calc(100% - 130px)', 'height': '20px', marginBottom: (showAddMore && parentIndex >= 1) ? '4px' : '10px' }}>
									<div className='form-group1'>
										<p
											onClick={() => removeSection(parentIndex)}
											className='btn btn-custom mr-1'
											style={{ 'float': 'right', cursor: 'pointer', backgroundColor: '#ea652b', color: 'white' }}
										>
											Remove Collateral
										</p>
									</div>
								</div>
							)}
						</div>
						{(body[parentId] || []).length - 1 !== parentIndex && (
							<>
								<hr className='' style={{ 'background': 'rgb(213, 213, 213)' }} />
								<p style={{ fontSize: '13px', color: '#ea652b', marginTop: '-15px' }}>{`${title?.split(' ')[0]} Info ${parentIndex + 2}`}</p>
							</>
						)}
					</>
				))}

				{showAddMore && (body[parentId] || []).length <= 2 && ((leadId && edit) || !leadId) && type === 'multiple' && (
					<div className='col-md-44' style={{ cursor: 'pointer', 'float': 'right', 'marginTop': '-32px' }}>
						<div className='form-group1'>
							<p
								onClick={addNewSection}
								className='btn btn-custom mt-2'
								style={{ cursor: 'pointer' }}
							>
								Add Collateral
							</p>

						</div>
					</div>
				)}
			</>
		);

	return (
		<div className='row mt-3'>
			{params.map(({ label, value, id, rule, hint }, index) => (
				<SectionItem
					required={value}
					body={body}
					setBody={setBody}
					parentId={parentId}
					label={label}
					hint={hint}
					key={index}
					id={id}
					rule={rule}
					params={params}
					errors={errors}
					edit={edit}
					leadId={leadId}
					selectedLender={selectedLender}
					setErrors={setErrors}
				/>
			))}
		</div>
	);
};

export default SectionContent;
